var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudits(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1029_17686",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 21.5V2.5H2.5V21.5H21.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1029_17686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6432 3.72184V17.6261C17.6432 18.0448 17.3038 18.3843 16.885 18.3843H14.6526C14.6526 16.919 13.4651 15.7311 11.9999 15.7311C10.5347 15.7311 9.34679 16.919 9.34679 18.3843H7.11438C6.69602 18.3843 6.35657 18.0448 6.35657 17.6261V3.72184C6.35657 3.30348 6.69602 2.96403 7.11438 2.96403H16.885C17.3038 2.96403 17.6432 3.30348 17.6432 3.72184Z",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8035 10.7441L21.5929 7.1257C21.6761 6.74406 21.4343 6.36707 21.0526 6.28387L17.6433 5.54012V17.6257C17.6433 18.0444 17.3038 18.3839 16.8851 18.3839H14.6527C14.6527 18.803 14.5554 19.1995 14.382 19.5518L17.987 20.3381C18.3683 20.4213 18.7453 20.1795 18.8284 19.7979L20.0711 14.1017",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34761 18.4533C9.34722 18.4303 9.34682 18.4073 9.34682 18.3839H7.1148C6.69606 18.3839 6.3566 18.0444 6.3566 17.6257V5.54012L2.94724 6.28387C2.5656 6.36707 2.32381 6.74402 2.40701 7.1257L5.17145 19.7979C5.25466 20.1795 5.63161 20.4213 6.01285 20.3381L9.61753 19.5518C9.45346 19.219 9.35776 18.8471 9.34761 18.4533Z",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6527 18.3837C14.6527 19.8489 13.4649 21.0366 11.9998 21.0366C10.5346 21.0366 9.3468 19.8489 9.3468 18.3837C9.3468 16.9185 10.5346 15.7307 11.9998 15.7307C13.4649 15.7307 14.6527 16.9185 14.6527 18.3837Z",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0104 18.5867L11.6756 19.252L13.0786 17.849",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0012 5.69629H15.2017",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 13.6436H13.0862",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 8.3457H15.2017",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59631 10.9941H15.2017",
    stroke: "#7A808F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudits);
export default __webpack_public_path__ + "static/media/audits.5d760bd1cf742815b81c107891bd20a4.svg";
export { ForwardRef as ReactComponent };